<template>
    <div id="wrapper" v-if="isClient" :class="mainWrapper">
        <Header />
        <main id="main" :class="wrapperClass">
            <slot></slot>
        </main>
        <Footer />
        <div class="c-toaster-top-full">
            <div class="c-toaster-slot" id="c-toaster-slot" :style="{
                'transform': isScrolling ? 'translateY(20px)' : 'translateY(130px)'
            }"></div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import Header from "@/esf_venlo_base/core/components/common/Header";
import Footer from "@/esf_venlo_base/core/components/common/Footer";
// import CookieBarWrap from "@/esf_venlo_base/core/components/CookieBar";
// import { setI18nLanguage } from "@storefront/core/i18n";

// import ClientOnly from "vue-client-only";
const isClient = ref(false);
const isScrolling = ref(false);

onMounted(() => {
    isClient.value = true;
    window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});

const handleScroll = () => {
    isScrolling.value = window.scrollY > 100;
};

const props = defineProps({
    wrapperClass: {
        type: String,
        required: false,
    },
    mainWrapper: {
        type: String,
        required: false,
    }
});
</script>